import React from "react";
import { Trans } from "react-i18next";
import { Icon } from "@blueprintjs/core";


export const CS_IN_PROGRESS = 0;
export const CS_ON_HOLD = 1;
export const CS_NO_CALL = 2;

export default function CallState(props) {
  return <div>
    {
      {

        0 /* IN_PROGRESS */: <div>
          <div style={{ visibility: "hidden" }}>HIDDEN</div>
          <div className="flexbox-center"><Icon icon="phone" size={50} className="pickUp" /></div>
          <div className="flexbox-center"><Trans>call in progress</Trans></div>
          {/* one empty line for alignment */}
          <div style={{ visibility: "hidden" }}>HIDDEN</div>

        </div>,

        1 /* ON_HOLD */: <div>
          <div style={{ visibility: "hidden" }}>HIDDEN</div>
          <div className="flexbox-center"><Icon icon="pause" size={50} /></div>
          <div className="flexbox-center"><Trans>call_status_on hold</Trans></div>
          {/* <div className="flexbox-center"><Trans>you can press the blue button to unhold the call.</Trans></div> */}
          <div style={{ visibility: "hidden" }}>HIDDEN</div>
        </div>,

        2 /* NO_CALL */: <div>
          <div style={{ visibility: "hidden" }}>HIDDEN</div>
          <div className="flexbox-center"><Icon icon="phone" style={{ transform: "rotate(135deg)", borderRadius: "200px" }} size={50} /></div>
          <div style={{ visibility: "hidden" }}>HIDDEN</div>
        </div>,

      }[props.status]
    }
  </div>
}

